angular.module("vgresiduos").controller("ResidueMarketHomeCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `mercado/home`);
		};
	}
]);
